import Accordion from 'accordion-js'

/**
 * Initialize every accordion.
 *
 * This component needs the JS file enqueued from https://www.npmjs.com/package/accordion-js
 *
 * Initialization doc help: https://github.com/michu2k/Accordion/issues/7
 */
export default function accordion() {
  const accordions = document.querySelectorAll( '.js-accordion' )

  initialize( accordions )
  setFocus( accordions )

  /**
   * Initializes the accordion-js library.
   *
   * @param {array} accordions An array with all the accordion nodes.
   */
  function initialize( accordions ) {
    const options = {
      triggerClass: 'ac-q',
      panelClass: 'ac-a',

      beforeClose: currentElement => {
        const button = currentElement.querySelector( '.ac-q' )
        button.classList.remove( 'bg-icon-contract' )
        button.classList.add( 'bg-icon-expand' )
      },

      beforeOpen: currentElement => {
        const button = currentElement.querySelector( '.ac-q' )
        button.classList.add( 'bg-icon-contract' )
        button.classList.remove( 'bg-icon-expand' )
      }
    }

    if ( accordions ) {
      let count = 0

      Array.from( accordions ).forEach( item => {
        count += 1

        item = microcampaignIntegritySection( item )

        if ( item.classList.contains( 'js-accordion-open-first' ) ) {
          options.openOnInit = [0]

          const firstItemButton = item.querySelector( 'button' )

          if ( firstItemButton ) {
            firstItemButton.classList.add( 'bg-icon-contract' )
            firstItemButton.classList.remove( 'bg-icon-expand' )
          }
        }

        if ( item.querySelector( '.ac' ) ) {
          const id = `accordion${ count }`
          item.id = id
          new Accordion( `#${ id }`, options )
        }
      })
    }
  }

  /**
   * Toggles the accordion rows focus style.
   *
   * @param {array} accordions An array with all the accordion nodes.
   */
  function setFocus( accordions ) {
    Array.from( accordions ).forEach( accordion => {

      Array.from( accordion.querySelectorAll( '.ac-q' ) ).forEach( accordionItem => {
        accordionItem.addEventListener( 'focus', () => {
          accordionItem.parentElement.classList.add( 'border-blue-60' )
        })

        accordionItem.addEventListener( 'focusout', () => {
          accordionItem.parentElement.classList.remove( 'border-blue-60' )
        })
      })
    })
  }

  /**
   * Custom behavior for accordion inside the section .gcc_microcampaign-integrity
   *
   * @param {element} item Element item
   *
   * @returns {element} The modified element.
   */
  function microcampaignIntegritySection( item ) {
    const gccMicrocampaignIntegritySection = item.closest( '.gcc_microcampaign-integrity' )

    if ( gccMicrocampaignIntegritySection ) {
      item.classList.add( 'js-accordion-open-first' )
    }

    return item
  }
}
